import { render, staticRenderFns } from "./ResendActivationEmail.vue?vue&type=template&id=af9f8d10"
import script from "./ResendActivationEmail.vue?vue&type=script&lang=js"
export * from "./ResendActivationEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports